import { YES_FLAG, NO_FLAG } from '../../shared/constants';

export const ModalNames = {
  ClientAddAndEdit: 'ClientAddAndEdit',
  ClientDelete: 'ClientDelete',
};

export const ModalTitles = {
  ADD: 'Add Client',
  EDIT: 'Edit Client',
};

export const CLIENT_INDEX_KEYS = ['clientId'];

export const CONVERSION_RATES_SOURCES = {
  TLS: {
    label: 'TLS',
    value: 'TLS',
  },
};

export const LEGAL_ENTITIES_SOURCES = {
  GLDRPT: {
    label: 'GLDRPT',
    value: 'GLDRPT',
  },
  TLS: {
    label: 'TLS',
    value: 'TLS',
  },
  EO: {
    label: 'EO',
    value: 'EO',
  },
};

export const COMPANY_CODES_SOURCES = {
  GLDRPT: {
    label: 'GLDRPT',
    value: 'GLDRPT',
  },
  TLS: {
    label: 'TLS',
    value: 'TLS',
  },
  EO: {
    label: 'EO',
    value: 'EO',
  },
};

export const COUNTRY_CODES_SOURCES = {
  INC: {
    label: 'Country of Incorporation',
    value: 'INC',
  },
  RES: {
    label: 'Tax Resident',
    value: 'RES',
  },
};

export const enabledFlagOptions = [
  {
    label: 'Yes',
    value: YES_FLAG,
  },
  {
    label: 'No',
    value: NO_FLAG,
  },
];

export const monthAbbr = [
  {
    label: 'JAN',
    value: 'JAN',
  },
  {
    label: 'FEB',
    value: 'FEB',
  },
  {
    label: 'MAR',
    value: 'MAR',
  },
  {
    label: 'APR',
    value: 'APR',
  },
  {
    label: 'MAY',
    value: 'MAY',
  },
  {
    label: 'JUN',
    value: 'JUN',
  },
  {
    label: 'JUL',
    value: 'JUL',
  },
  {
    label: 'AUG',
    value: 'AUG',
  },
  {
    label: 'SEP',
    value: 'SEP',
  },
  {
    label: 'OCT',
    value: 'OCT',
  },
  {
    label: 'NOV',
    value: 'NOV',
  },
  {
    label: 'DEC',
    value: 'DEC',
  },
];
